import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as serviceApi from "../../../api/service";

export function useServices() {
  return useQuery({
    queryKey: ["services"],
    queryFn: () => serviceApi.fetchAll(),
  });
}

export function useSaveService() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => serviceApi.save(null, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["services"] }),
  });
}

export function useArchiveService() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ service, location }) =>
      serviceApi.archive(null, service, location),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["services"] }),
  });
}
